module.exports = __webpack_public_path__ + "img/menuBackground.28914462.png";